// Ported from dev-scrips-pm-react src/billing/lib/sponsor-type.ts (PROD-3312 appointment Billing tab).
/**
 * Single source of truth for sponsor-type classification (PROD-1006, Samer
 * review). The wire `sponsorType` is a string ("Self-pay" / "Insurance" /
 * "Corporate"); we normalise (strip non-letters + lowercase) so casing/
 * punctuation drift ("self pay", "SELF-PAY") can't silently flip the gate.
 * Used by the totals box, the invoice services table, and InvoiceDetailPage so
 * the Self-pay gating can never diverge between them.
 */
const norm = (s: string | null | undefined) =>
  (s ?? '').replace(/[^a-z]/gi, '').toLowerCase();

export function isSelfPay(sponsorType: string | null | undefined): boolean {
  return norm(sponsorType) === 'selfpay';
}

export function isInsurance(sponsorType: string | null | undefined): boolean {
  return norm(sponsorType) === 'insurance';
}
